import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VatDto } from '../interfaces';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VatsService {
  private iCourrierURL;
  constructor(private http: HttpClient) {
    const config = environment;
    this.iCourrierURL = config.apiICourrierBaseUrl;
  }

  public fetchVats(ids?: number[], type?: string): Observable<VatDto[]> {
    if (ids || type) {
      return this.http.get<VatDto[]>(`${this.iCourrierURL}/Global/Bacs`, { params: { ids: ids.join(','), type } });
    } else {
      return this.http.get<VatDto[]>(`${this.iCourrierURL}/Global/Bacs`);
    }
  }
}
